<template>
  <div class="tusgaiZuvshuurul">
    <div class="container">
      <div class="tusgaiZuvshuurul_top">
        <div class="row">
          <div class="col-md-4">
            <div class="left">
              <h3>Сургалтын бүртгэлийн гэрчилгээ</h3>
            </div>
          </div>
          <div class="col-md-8">
            <div class="right">
              <Select v-model="mergejil" placeholder="Сургалтын төрөл" clearable filterable>
                <Option v-for="tpname in mergejiluud" :value="tpname.tp_name_id" :key="tpname.index">{{
                    tpname.tp_name
                  }}
                </Option>
              </Select>
              <Input @on-search="calldata"  search enter-button placeholder="Хайх..." v-model="searchWord"/>

            </div>
          </div>
        </div>
      </div>
      <div class="surgalt_bvrtgeliin_gerchilgee_table">
        <div class="row">
          <div class="col-md-12">
            <table width="100%">
              <thead>
              <tr>
                <th>ДУГААР</th>
                <th>АЙМАГ / ХОТ</th>
                <th>СУРГАЛТЫН ТӨРӨЛ</th>
                <th>ШИЙДВЭРИЙН ДУГААР</th>
                <th>БАЙГУУЛЛАГА</th>
                <th>ЭХЛЭХ ОГНОО</th>
                <th>ДУУСАХ ОГНОО</th>
                <th>ХАЯГ</th>
              </tr>
              </thead>
              <tbody>
              <tr :key="index" v-for="(lis, index) in list">
                <td>{{ lis.dugaar }}</td>
                <td>{{ lis.aimagname }}</td>
                <td>{{ getMergejilTitle(lis.surgaltiin_turul_id) }}</td>
                <td>{{ lis.shiidver_dugaar }}</td>
                <td>{{ lis.ner_mn }}</td>
                <td>{{ lis.ehleh_ognoo | datev}}</td>
                <td>{{ lis.duusah_ognoo | date }}</td>
                <td>
                  <Tooltip max-width="140" :content="lis.hayag">
                    <div class="hayg">
                      <i class="fa fa-map-marker"></i>
                    </div>
                  </Tooltip>
                </td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
         <span class="total-info">
            Нийт: <b>{{ total }}</b>
         </span>
        </div>
        <div class="col-md-9">
          <div class="pagenation">
            <Page @on-change="changePageTusgai"
                  :current-page="current_page"
                  :page-size="9"
                  :total="total"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getBurtegliinGerchilgee, getMergejiluud} from "../api/index"

export default {

  components: {},
  data() {
    return {
      list: [],
      mergejiluud: [],
      mergejil: null,
      searchWord: null,
      current_page: 1,
      last_page: 1,
      total: 0,
    }
  },
  mounted() {

    this.calldata();

    this.callFilterData();
  },
  methods: {
    getMergejilTitle(tpIDs) {
      let ids = tpIDs.split(",")

      if (ids.length >= 1) {
        let filtred = this.mergejiluud.filter(mergejil => {
          if (ids.findIndex(id => id == mergejil.tp_name_id) >= 0) {
            return true
          } else {
            return false
          }
        })
        let names = filtred.map(title => title.tp_name);
        return names.join(', ')
      } else {
        return ""
      }

    },
    callFilterData() {
      getMergejiluud().then(r => {
        this.mergejiluud = r.data;
      });
    },
    calldata() {
      this.$isLoading(true);
      getBurtegliinGerchilgee(this.current_page, {
        mergejil: this.mergejil,
        searchWord: this.searchWord
      }).then(response => {
        this.list = response.data.data;
        this.current_page = response.data.current_page;
        this.total = response.data.total;

        this.$isLoading(false);


      }).catch(error => {
        this.$Loading.error();
        console.log('ErrorL ', error);
      });
    },
    changePageTusgai(page) {
      this.current_page = page;
      this.calldata();
    },
  },
}
</script>
